<template>
    <div>

        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-3">
                        <az-input   
                            type="month"
                            v-model="filtros.mes">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-primary" @click="load()">
                                        <i class="fa-solid fa-rotate fa-fw"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                            
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="far fa-building fa-fw"
                            type="select"
                            placeholder="Todas as Unidades..."
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            v-model="filtros.id_unidade_operacao" />
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input
                            type="text"
                            icon="fa fa-search"
                            placeholder="Pesquisar..."
                            v-model="search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-primary" @click="compor_selecionados ()" :disabled="compondo">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12">
                        <az-input
                            sizing="sm"
                            type="button-group"
                            :optionsList="[
                                { id: 'M', search: 'Profissional' },
                                { id: 'U', search: 'Unidade' },
                                { id: 'E', search: 'Especialidade' },
                            ]"
                            optionsData="id" 
                            v-model="filtros.grupo"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3">
            <az-input
                label="Categoria"
                :compact="true"
                sizing="sm"
                type="select"
                optionsMode="aql"
                optionsName="categorias.lancamento.saidas.repasse"
                :optionsParm="{ lancamento: false, where: { ch_natureza: 'D' } }"
                service="categorias.index" 
                optionsData="id_categoria"
                v-model="id_categoria_repasse">
                <template v-slot:buttonposb>
                    <div class="input-group-append" v-if="id_categoria_repasse">
                        <span class="input-group-text" id="basic-addon1">#{{ id_categoria_repasse }}</span>
                        <az-submit @click="salvar_categoria()" color="outline-success" :hide_content_while_loading="true">
                            <i class="fa fa-check fa-fw" aria-hidden="true"></i>
                        </az-submit>
                    </div>
                </template>
            </az-input>
        </div>

        <div class="alert alert-info mt-3">
            Apuração da previsão de repasse baseada nos atendimentos, para composição do DRE.
        </div>

        <div v-if="progressao || progressao === 0">
            <div>Processando...</div>
            <div class="progress mb-3">
                <div class="progress-bar" role="progressbar" :style="'width: ' + progressao + '%; height: 12px;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        </div>

        <div v-if="lista_previsao && !lista_previsao.analitico && lista_previsao.lista && lista_previsao.lista.length">
            
            <table class="table bg-white table-hover">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th class="text-right">Valor</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, iix) in lista_previsao.lista" :key="iix">
                        <td>{{ item.descricao }}</td>
                        <td class="text-right">{{ $util.formatMoeda(item.valor_total) }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th>Total</th>
                        <th class="text-right">{{ $util.formatMoeda(totalizar(lista_previsao.lista, 'valor_total')) }}</th>
                    </tr>
                </tfoot>
            </table>

            <az-submit type="button" class="btn btn-danger" @click="remover_apuracao()">Remover</az-submit>

        </div>

        <div v-else>
            <az-empty-state msg="Nenhum profissional identificado." />
        </div>

        <pre v-if="false">{{ lista_previsao }}</pre>

        <template v-if="vai_apurar">
            <repasse-apuracao 
                ref="apura_mult"
                :mult="true"
                :item="periodo" 
                :dre="true"
                origem="P" 
                @compor="compor_selecionados" />
        </template>

    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import RepasseApuracao from '../repasse/RepasseApuracao.vue';
import { subscribe, unSubscribe } from "../../../service/Notify";
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return {    
            search: "", 
            vai_apurar: false, 
            filtros: { 
                mes: "",
                id_unidade_operacao: "",
                grupo: "M", 
            },
            lista_previsao: [], 
            compondo: false, 
            progressao: null, 
            id_categoria_repasse: "", 
        };
    },

    components: { 
        AzInput, 
        RepasseApuracao,
        AzEmptyState, 
        AzSubmit, 
    },

    computed: { 
        periodo: function () { 
            if ( !this.filtros.mes ) { 
                return null;
            }

            return { 
                dt_inicio: this.filtros.mes + "-01",
                dt_termino: this.$util.ultimo_dia_mes(this.filtros.mes)
            };
        }
    },

    methods: { 
        remover_apuracao () { 
            if ( !confirm('Confirma remover a apuração de ' + this.filtros.mes + '?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'remover_previsao_dre',
                dados: { 
                    mes: this.filtros.mes, 
                    id_unidade_operacao: this.filtros.id_unidade_operacao,
                },
                toast: true, 
                reload: true, 
            });
        },

        salvar_categoria () { 
            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'salvar_categoria_repasse',
                dados: { 
                    id_categoria_repasse: this.id_categoria_repasse, 
                },
                toast: true, 
            });
        },

        totalizar (lista, campo) { 
            return _.sumBy(lista, campo);
        },

        load () { 
            this.$util.load(this, { 
                service: 'repasses', 
                func: 'consultar_previsao',
                parms: { 
                    data: this.filtros.mes, 
                    grupo: this.filtros.grupo, 
                    id_unidade_operacao: this.filtros.id_unidade_operacao, 
                },
                loadTo: res => { 
                    this.lista_previsao = res; 
                }
            });
        },

        compor_selecionados (filtros = null) { 

            if ( !filtros ) {
                if ( !this.periodo ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Selecione um mês para apuração.",
                        life: 5000
                    });

                    return;
                }

                this.vai_apurar = false;

                this.$nextTick(() => { 
                    this.vai_apurar = true;

                    this.$nextTick(() => { 
                        this.$refs.apura_mult.selecionar_apuracao();
                    });
                });
                return;
            }

            this.compondo = true;

            let lista_filtros = _.cloneDeep(filtros);

            lista_filtros.filtros.forEach(item => {
                if ( item.model && item.model.forma_pagamento ) { 
                    item.model.forma_pagamento = null;
                }
            });

            this.progressao = 0;

            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'compor_mult_previsao',
                dados: { 
                    filtros: lista_filtros, 
                },
                toast: true,
                msg: 'Composição em andamento.'
            });

            this.evento_subscribe = "repasse-compor-mult-prev" + this.$store.state.user.id_usuario;

            subscribe(this.$store.state.dominio, this.evento_subscribe, 
                (retorno) => {
                    if ( this.item ) { 
                        // this.editar_repasse(this.item);
                    }

                    if ( retorno.data.fim ) { 
                        unSubscribe(this.$store.state.dominio, this.evento_subscribe);
                        this.evento_subscribe = "";
                        this.compondo = false;

                        this.$toast.add({
                            severity: "success",
                            summary: "Atenção",
                            detail: retorno.data.mensagem,
                            life: 6000
                        });

                        this.progressao = null;

                        this.load();
                    } else if ( retorno.data.mensagem ) { 

                        this.progressao = retorno.data.percent;

                        this.$toast.add({
                            severity: "info",
                            summary: "Atenção",
                            detail: retorno.data.mensagem,
                            life: 3000
                        });

                    }

                }
            );

        },
    },

    mounted() { 

        this.$store.commit("setBreadcrumb", [
            { name: "Financeiro", path: "/financeiro/visao" },
            { name: "Apuração de Previsão de Repasse", path: "/financeiro/previsao-repasse" },
        ]);

        this.$util.loadItem(this, { 
            service: 'configuracoes',
            func: 'index', 
            parms: {
                where: {
                    st_slug: 'dre-categoria-repasse	',
                },
            },
        })
        .then(res => { 
            this.id_categoria_repasse = _.get(res, '0.st_valor');
        })

    }
}
</script>
